//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: {
      type: Object
    }
  },
  mounted: function mounted() {},
  data: function data() {
    return {};
  },
  methods: {
    gotoBrand: function gotoBrand() {
      var _this$item = this.item,
        id = _this$item.id,
        dataSeed = _this$item.dataSeed;
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
      this.go("/brand/detail/".concat(id));
    }
  }
};